<script lang="ts">
	import ReaderStart from '$lib/components/reader/reader-start.svelte';

	let { data } = $props();

	let storySlug = $derived(data.storySlug);
	let storyMetadata = $derived(data.storyMetadata);
	let images = $derived(data.images);
	let isInLibrary = $derived(data.isInLibrary);
</script>

<div class="px-0">
	<ReaderStart
		title={storyMetadata.title}
		blurb={storyMetadata.blurb}
		{storySlug}
		{images}
		labels={storyMetadata.labels}
		{isInLibrary}
	/>
</div>
